// extracted by mini-css-extract-plugin
export default {"two":"SecTwo_two__jZLvm","twoMain":"SecTwo_twoMain__Xgar8","text":"SecTwo_text__KkSvF","img":"SecTwo_img__FL32P"};